import { auth as en_auth } from "../en/auth";

/** auth — RU slice (63 keys). */
export const auth: Record<keyof typeof en_auth, string> = {
  auth_welcome_title: "Привет",
  auth_welcome_subtitle: "Войди или создай аккаунт",
  auth_continue_with_email: "Продолжить с почтой",
  auth_or: "или",
  auth_signin_title: "Вход по почте",
  auth_signin_email_label: "Почта",
  auth_signin_email_placeholder: "you@example.com",
  auth_signin_password_label: "Пароль",
  auth_signin_password_placeholder: "Твой пароль",
  auth_signin_button: "Войти",
  auth_signin_loading: "Входим...",
  auth_signin_forgot: "Забыл?",
  auth_signin_no_account: "Нет аккаунта?",
  auth_signin_create_account: "Создать аккаунт",
  auth_signup_email_title: "Создать аккаунт",
  auth_signup_email_subtitle: "Укажи почту, чтобы начать",
  auth_signup_already_have_account: "Уже есть аккаунт?",
  auth_signup_password_title: "Придумай пароль",
  auth_signup_password_subtitle: "Задай пароль для аккаунта",
  auth_signup_password_label: "Пароль",
  auth_signup_password_placeholder: "Мин. 8 символов",
  auth_signup_password_change: "Изменить",
  auth_signup_button: "Создать аккаунт",
  auth_signup_loading: "Создаём аккаунт...",
  auth_verify_title: "Подтверди почту",
  auth_verify_subtitle: "Мы отправили код на {email}",
  auth_verify_resend: "Не пришёл код?",
  auth_verify_resend_button: "Отправить снова",
  auth_verify_resent: "Код отправлен!",
  auth_forgot_title: "Забыл пароль",
  auth_forgot_subtitle: "Укажи почту, чтобы сбросить пароль",
  auth_forgot_button: "Отправить код",
  auth_forgot_loading: "Отправляем код...",
  auth_forgot_back: "Назад ко входу",
  auth_reset_title: "Сброс пароля",
  auth_reset_subtitle: "Введи код, отправленный на {email}",
  auth_reset_password_label: "Новый пароль",
  auth_reset_button: "Сбросить пароль",
  auth_reset_loading: "Сбрасываем...",
  auth_change_email_title: "Сменить почту",
  auth_change_email_subtitle: "Укажи новый адрес почты",
  auth_change_email_current: "Текущая почта",
  auth_change_email_new_label: "Новая почта",
  auth_change_email_new_placeholder: "new@example.com",
  auth_change_email_button: "Продолжить",
  auth_change_email_loading: "Отправляем код...",
  auth_change_email_verify_title: "Подтверди личность",
  auth_change_email_verify_subtitle: "Мы отправили код на {email}",
  auth_change_email_verify_new_title: "Подтверди новую почту",
  auth_change_email_verify_new_subtitle: "Мы отправили код на {email}",
  auth_change_email_done_title: "Почта обновлена",
  auth_change_email_done_subtitle: "Твоя почта изменена на {email}",
  auth_change_email_done_button: "Готово",
  auth_dashboard_title: "Панель",
  auth_dashboard_subtitle: "Ты вошёл",
  auth_dashboard_email: "Почта",
  auth_dashboard_user_id: "ID пользователя",
  auth_dashboard_email_verified: "Почта подтверждена",
  auth_dashboard_yes: "Да",
  auth_dashboard_no: "Нет",
  auth_dashboard_signout: "Выйти",
  auth_loading: "Загрузка...",
  auth_loading_session: "Загружаем сессию...",
};
